import { AddressSplit } from './addressSplit'

export const OldAddressSplit = (props) => {
  return <AddressSplit {...props} twoLevels={false} />
}